var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEEADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1624_15060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4387 12.2609L16.0001 13.0625L15.5615 12.2609C15.3028 11.7882 14.8714 11.1546 14.2372 10.6641L14.5406 10.2718L14.2372 10.6641C13.5842 10.1591 12.8534 9.90784 12.0527 9.90784C9.81595 9.90784 8.07904 11.731 8.07904 14.2603C8.07904 15.6008 8.6103 16.7499 9.61774 17.9655C10.6379 19.1965 12.1073 20.4509 13.9348 22.0083L13.6105 22.3888L13.9348 22.0083L13.935 22.0084C14.5519 22.5342 15.2533 23.1319 15.9828 23.7699L15.983 23.77C15.9874 23.7739 15.9933 23.7763 16.0001 23.7763C16.0069 23.7763 16.0128 23.7739 16.0171 23.77L16.0174 23.7698C16.7463 23.1324 17.4472 22.535 18.0635 22.0098L18.065 22.0086L18.065 22.0086C19.8927 20.451 21.3622 19.1966 22.3824 17.9656C23.3899 16.7499 23.9211 15.6008 23.9211 14.2603C23.9211 11.731 22.1842 9.90784 19.9475 9.90784C19.1468 9.90784 18.416 10.1591 17.763 10.6641L17.4571 10.2686L17.763 10.6641C17.1288 11.1546 16.6974 11.7881 16.4387 12.2609Z",
    stroke: "#E18F91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_15060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8421,
    height: 16.8421,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.4211 8.42102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/favourite-icon.5be9f6044cdfc5d4227e519ab60cc89a.svg";
export { ForwardRef as ReactComponent };